import React from "react"
import { useParams } from "react-router-dom"
import { EDIT } from "../../include/constant"
import VoucherForm from "../common/VoucherForm"
import SuperAdminHeader from "./Header"

const SuperAdminEditVoucher = () => {
    const { id } = useParams()

    return <div className="fixed-top-bar">
        <SuperAdminHeader />
        <VoucherForm
            id={id}
            title="Edit Voucher"
            type={EDIT}
        />
    </div>
}

export default SuperAdminEditVoucher